module.exports = __webpack_public_path__ + "static/AW_student_1-d6b45b47d6bdf66424c87b48b4dfbce7.jpg";